export function Minus(props: any) {
    return (
        <svg width={36} height={36} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width={36} height={36} rx={18} fill="#fff" />
            <path d="M22.77 16.818v4.136h-9.545v-4.136h9.545Z" fill="#377CB9" />
        </svg>
    );
}
